import {createAction} from "../../factory/redux/action";

export const ACTION_TYPE = Object.freeze({
    SET_COMMENT_SELECTOR: "SET_COMMENT_SELECTOR"
});

export const SET_COMMENT_SELECTOR = (payload) => createAction(
    ACTION_TYPE.SET_COMMENT_SELECTOR,
    payload
);